module.exports = __webpack_public_path__ + "assets/TriangleBySidesDetailed.cb18d12cf5feafdbe57e331a773ffd0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TriangleBySidesDetailed.png
// module id = 596
// module chunks = 0